import React, { useState } from "react";
import { AiFillCloseCircle } from 'react-icons/ai'
const formatPrice = (price) => {
  return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

const ProductModal = ({ onClose, title, price, imageSrc, colors, sizes }) => {
  const formattedPrice = formatPrice(price);

  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  const handleColorClick = (color) => {
    setSelectedColor(color);
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  return (
    <div className="modal">
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content">
        <div className="modal-image">
          <img alt="product" src={imageSrc} />
        </div>
        {/*
        <div className="modal-text">
          <div className="modal-title">{title}</div>
          <div className="modal-price">₡{formattedPrice}</div>
          <div className="modal-SKU">SKU: 364115376135191</div>
          ...other fields hidden for now...
        </div>
        */}
        <div onClick={onClose} className="close-modal-button" style={{position:'absolute', top:'10px', right:'10px'}}><AiFillCloseCircle size={26}/></div>
      </div>
    </div>
  );
};

export default ProductModal;
